import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_474: DocMigration = {
  maxSchemaVersion: "0.0.474",
  description: "Rename analytic view filter categories",
  apply(json: any) {
    json.planViews = json.planViews ?? {};
    for (const id in json.planViews) {
      const planView = json.planViews[id];
      migrateViewFilter(planView.viewFilter);
    }
    json.view3Ds = json.view3Ds ?? {};
    for (const id in json.view3Ds) {
      const view3D = json.view3Ds[id];
      migrateViewFilter(view3D.viewFilter);
    }
    json.elevationViews = json.elevationViews ?? {};
    for (const id in json.elevationViews) {
      const elevationView = json.elevationViews[id];
      migrateViewFilter(elevationView.viewFilter);
    }
    json.sectionViews = json.sectionViews ?? {};
    for (const id in json.sectionViews) {
      const sectionView = json.sectionViews[id];
      migrateViewFilter(sectionView.viewFilter);
    }
    return json;
  },
};

function migrateViewFilter(viewFilter: any) {
  if (viewFilter === undefined) {
    return;
  }
  if (viewFilter.roofSoffits !== undefined) {
    viewFilter.analyticRoofSoffits = viewFilter.roofSoffits;
    delete viewFilter.roofSoffits;
  }
  if (viewFilter.foundationSlabs !== undefined) {
    viewFilter.analyticFoundationSlabs = viewFilter.foundationSlabs;
    delete viewFilter.foundationSlabs;
  }
  if (viewFilter.foundationFootings !== undefined) {
    viewFilter.analyticFoundationFootings = viewFilter.foundationFootings;
    delete viewFilter.foundationFootings;
  }
  if (viewFilter.foundationStemWalls !== undefined) {
    viewFilter.analyticStemWalls = viewFilter.foundationStemWalls;
    delete viewFilter.foundationStemWalls;
  }
  return viewFilter;
}

export default migration_0_0_474;
